import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ShareButton from '../components/ShareButton';
import SearchBar, { matches } from '../components/SearchBar';
import { PlanRow, usePlanActions } from '../components/PlanParts';
import { useAuth } from '../context/AuthContext';

// Page Plans : documents PDF / Word. L'admin connectée peut ajouter et supprimer des plans.
export default function Plans() {
  const { token, authFetch } = useAuth();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [q, setQ] = useState('');
  const [flash, setFlash] = useState(null);

  const load = () => fetch('/api/plans')
    .then(r => r.ok ? r.json() : Promise.reject())
    .then(d => { setPlans(d); setError(false); })
    .catch(() => setError(true))
    .finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const actions = usePlanActions(authFetch, load, setFlash);

  const shown = plans.filter(p => matches(q, p.title, ...p.files.map(f => f.file_name)));
  return (
    <section className="section fade-in">
      <div className="section-head">
        <h2>plans</h2>
        <span className="head-right">
          <span className="counter">{String(plans.length).padStart(2, '0')} plan{plans.length > 1 ? 's' : ''}</span>
          <ShareButton variant="icon" title="Plans — Zahra's Learning" text="Des plans en PDF et Word à consulter ou télécharger" />
        </span>
      </div>
      {token && <div className="note-subject-tools note-subject-tools-top"><Link to="/admin/plans" className="btn">+ ajouter un plan</Link></div>}
      {flash && <div className={`flash ${flash.type === 'error' ? 'error' : ''}`}>{flash.text}</div>}

      {loading ? <div className="empty-state">chargement...</div> :
       error ? <div className="empty-state">impossible de charger les plans pour le moment — réessayez dans un instant.</div> :
       plans.length === 0 ? <div className="empty-state">rien encore ici ✎</div> : (
        <>
          <SearchBar value={q} onChange={setQ} placeholder="Rechercher un plan…" label="Rechercher un plan" count={shown.length} total={plans.length} unit="plan" />
          {shown.length === 0 && <div className="empty-state search-empty">aucun plan pour « {q} »<button type="button" className="btn secondary" onClick={() => setQ('')}>voir tous les plans</button></div>}
          <ul className="note-list">{shown.map(p => <PlanRow key={p.id} p={p} actions={token ? actions : null} />)}</ul>
        </>
      )}
    </section>
  );
}
